import type { NavigationIconName } from '@content';
import { cn } from '@lib/theme';
import type { ReactElement } from 'react';

interface NavigationIconProps {
  variant: NavigationIconName;
  className?: string;
  size?: 'sm' | 'md';
}

const containerStyles = 'border-border bg-secondary relative flex items-center justify-center rounded-xl border';

const iconSizeMap = {
  sm: 'h-12 w-12',
  md: 'h-14 w-14',
};

const iconClassName = 'h-7 w-7 object-contain';

const getIcon = (name: NavigationIconName): ReactElement => {
  return (
    <img
      src={`/assets/optimized/icons/${name}.webp`}
      alt=""
      className={iconClassName}
      width={32}
      height={32}
      loading="lazy"
      decoding="async"
    />
  );
};

export function NavigationIcon({ variant, className, size = 'md' }: NavigationIconProps) {
  return (
    <span className={cn(containerStyles, iconSizeMap[size], className)} aria-hidden="true">
      {getIcon(variant)}
    </span>
  );
}
